import { gql } from '@apollo/client';

export const GET_CLIENT_RULE = gql`
  query getClientRule($id: ID!) {
    clientRule(id: $id) {
      id
      ledgerAccount {
        id
      }
      vendorContains
      minAmount
      maxAmount
      priority
      sourceLedgerAccount {
        id
      }
    }
  }
`;

export const GET_LEDGER_ACCOUNTS = gql`
  query getLedgerAccounts($clientId: ID!) {
    ledgerAccounts(clientId: $clientId) {
      id
      name
      role
    }
  }
`;

export const CREATE_CLIENT_RULE = gql`
  mutation createClientRule($clientRule: CreateOrUpdateClientRule!) {
    createClientRule(clientRule: $clientRule) {
      id
    }
  }
`;

export const UPDATE_CLIENT_RULE = gql`
  mutation updateClientRule($id: ID!, $clientRule: CreateOrUpdateClientRule!) {
    updateClientRule(id: $id, clientRule: $clientRule) {
      id
      ledgerAccount {
        id
      }
      vendorContains
      priority
      minAmount
      maxAmount
      sourceLedgerAccount {
        id
      }
    }
  }
`;
